import { FieldRule } from '../../services/util/field-rules-manager/interfaces/fieldRuleInterfaces';
import React, { ReactNode } from 'react';
import { Form, FormItemProps, FormRule } from 'antd';

const AdmissionFormItem = ({ fieldRule, formItemProps, children }:
  { fieldRule?: FieldRule, formItemProps?: FormItemProps, children: ReactNode }) => {

  //copies , joins and formats itemProps to prevent rules to be overriden by props
  const formattedFormItemProps = {...formItemProps};
  const joinedRules : FormRule[] = [...fieldRule?.rules || [], ...formattedFormItemProps?.rules || [], ...[{required: fieldRule?.required}]];
  const effectiveRules  = joinedRules.reduce((result,current)=> {
    return {...result, ...current};
  },{});
  //deletes so that it won't override effectiveRules in the spread operator below when passing additional props
  delete formattedFormItemProps.rules;

  return (
    <Form.Item
      name={fieldRule?.name}
      label={fieldRule?.label}
      hidden={fieldRule?.hidden}
      rules={[effectiveRules]}
      initialValue={fieldRule?.defaultValue}
      {...formattedFormItemProps} // Spread additional Form.Item props
    >
      {React.cloneElement(children as React.ReactElement<any>, {
        placeholder: fieldRule?.placeholder || (children as React.ReactElement<any>).props.placeholder,
        disabled: fieldRule?.disabled || (children as React.ReactElement<any>).props.disabled,
      })}
    </Form.Item>
  );
};

export default AdmissionFormItem;